window.arjoDownloadBlockModule = window.arjoDownloadBlockModule || {
  isInitialized: false,
  expandEventHandler: function (tab) {
    tab.setAttribute('data-expand', '');
  },
  collapseEventHandler: function (tab) {
    tab.removeAttribute('data-expand');
  },
  init: function () {
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;

    const blocks = [...document.querySelectorAll('.arjo-o-download')];
    [].forEach.call(blocks, (block) => {
      const id = block.dataset.filterId;
      if (!id) {
        return;
      }
      const filterEventHandler = (e) => {
        const id = e.detail.id;
        if (!id) return;

        const tabs = [...block.querySelectorAll('.arjo-o-download__items')];
        [].forEach.call(tabs, (tab) => {
          tab.addEventListener('expand', () => this.expandEventHandler(tab));
          tab.addEventListener('collapse', () => this.collapseEventHandler(tab));
          if (!tab.querySelector('[data-toggle]')) {
            const expanderId = tab.getAttribute('data-expander');
            if (expanderId) {
              const expanderElement = document.getElementById(expanderId);
              if (expanderElement) {
                var deactiveEvent = new Event('deactive');
                expanderElement.dispatchEvent(deactiveEvent);
              }
            }
          }
          const filterTab = tab.dataset.filterTab;
          if (!filterTab) {
            return;
          }
          if (filterTab === id) {
            tab.classList.remove('arjo-o-download__items--hidden');
          } else {
            tab.classList.add('arjo-o-download__items--hidden');
          }
        });
      };
      window.addEventListener(id, filterEventHandler);

      const prefix = `#${id}-`;

      window.addEventListener('hashchange', () => {
        const hashingId = window.location.hash.includes(prefix) ? window.location.hash.replace(prefix, '') : undefined;

        const event = {
          detail: hashingId,
        }

        filterEventHandler(event);
      });
    });
  },
};
window.addEventListener('load', () => window.arjoDownloadBlockModule.init());
